// Ids match M5 reseed (20260729190000_firestore_migration_seeds): DELETE + re-INSERT with
// no explicit ids, continuing autoincrement past the 5 rows from seed_enumerations.
export var PickStatus;
(function (PickStatus) {
    PickStatus[PickStatus["DRAFT"] = 6] = "DRAFT";
    PickStatus[PickStatus["IN_PROGRESS"] = 7] = "IN_PROGRESS";
    PickStatus[PickStatus["COMMITTED"] = 8] = "COMMITTED";
    PickStatus[PickStatus["COMPLETED"] = 9] = "COMPLETED";
    PickStatus[PickStatus["CANCELLED"] = 10] = "CANCELLED";
})(PickStatus || (PickStatus = {}));
//# sourceMappingURL=pick-status.js.map